/* RESPONSIBLE TEAM: team-proactive-support */
import { EmbeddedRecordsMixin } from '@ember-data/serializer/rest';
import EmbercomBaseSerializer from 'embercom/serializers/base/embercom-base-serializer';

export default EmbercomBaseSerializer.extend(EmbeddedRecordsMixin, {
  attrs: {
    questions: { embedded: 'always' },
    survey: { key: 'survey_id' },
    stepType: { embedded: 'always' },
    actions: { embedded: 'always' },
  },
});
